import React, { useState } from 'react';
import { FileText, Download, Loader2 } from 'lucide-react';
import { indirPdfRapor } from './pdfRapor';
import { indirWordRapor } from './wordRapor';

// Zamanaşımı sonucu için Word/PDF rapor indirme butonları.
// Yakalama 100-500ms sürebildiğinden buton kilitlenir (çift tıklama önlenir).
export default function RaporIndirButonlari({ sonuc }) {
  const [busy, setBusy] = useState(null); // 'pdf' | 'word' | null
  const [hata, setHata] = useState(null);
  const [secimler, setSecimler] = useState({ sureOlusumu: true, asamalar: true });

  if (!sonuc || !sonuc.timelineModel) return null;

  const toggle = (k) => setSecimler((s) => ({ ...s, [k]: !s[k] }));

  const calistir = async (tur, fn) => {
    if (busy) return;
    setBusy(tur);
    setHata(null);
    try {
      await fn();
    } catch (e) {
      console.error('Rapor oluşturulamadı:', e);
      setHata('Rapor oluşturulamadı. Lütfen tekrar deneyin.');
    } finally {
      setBusy(null);
    }
  };

  const SECENEKLER = [
    { k: 'sureOlusumu', etiket: 'Sürenin oluşumu' },
    { k: 'asamalar', etiket: 'Aşama aşama geçen süre' },
  ];

  return (
    <div className="flex flex-col items-stretch gap-2 sm:items-end">
      <div className="flex flex-wrap gap-x-4 gap-y-1.5 sm:justify-end">
        {SECENEKLER.map((o) => (
          <label key={o.k} className="inline-flex items-center gap-1.5 text-xs text-slate-600">
            <input
              type="checkbox"
              checked={secimler[o.k]}
              onChange={() => toggle(o.k)}
              className="h-3.5 w-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500/40"
            />
            {o.etiket}
          </label>
        ))}
      </div>
      <p className="text-[11px] text-slate-400">Künye, etkin tarih ve zaman çizelgesi her zaman dahildir.</p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          disabled={!!busy}
          onClick={() => calistir('pdf', () => indirPdfRapor(sonuc, secimler))}
          className="inline-flex items-center justify-center gap-2 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {busy === 'pdf' ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileText className="h-4 w-4" />}
          PDF indir
        </button>
        <button
          type="button"
          disabled={!!busy}
          onClick={() => calistir('word', () => indirWordRapor(sonuc, secimler))}
          className="inline-flex items-center justify-center gap-2 rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition-colors hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-300 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {busy === 'word' ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />}
          Word indir
        </button>
      </div>
      {hata ? <p className="text-xs font-medium text-rose-600">{hata}</p> : null}
    </div>
  );
}
